<template>
    <div class="home-wrapper wrapper" :class="[maskData && (maskData.type == 1 || maskData.type == 2 || maskData.type == 3) && 'maskshow']"> 
        <div class="home-inner">
			<div class="banner">
				<div class="logo">
					<img src="https://yunyingcdn.thecover.cn/o_1du7590crdaf15jp2g79j8nfd9.png" alt="">
				</div>
				<img src="https://yunyingcdn.thecover.cn/o_1hbdeqi6f16cv1em981611gp14c19.jpg" alt="">
				<p class="time">活动时间：2023.9.28—2023.10.06</p>
			</div>
			<div class="home-main">
				<div class="home-rule">
					<h4 class="rule-title"><img src="https://yunyingcdn.thecover.cn/o_1dts8mm27rp534u1gu91ib21mvh44.png" alt=""></h4>
					<div class="home-rule-content">
						<!-- <p>1、登录封面新闻 app，带话题发布节日动态内容，每天可获 1次抽取现金红包资格。</p> -->
						<div class="">
              1、登录封面新闻 app，带话题发布节日动态内容，可获1次抽取现金红包资格。<br>
							2、转发分享 (自己的动态卡片或活动页面)，可多1次抽取现金红包资格。
							<div class="rule-link" @click="goRule" data-trackevent="click" data-tracklabel="查看规则详情" data-track="track">
								<div class="rule-link-inner">
									<img src="https://yunyingcdn.thecover.cn/o_1du6mh0agfia7fsse1cn816ch9.png" alt="">
									<span>规则详情</span>
								</div>						
							</div>
						</div>
						
					</div>					
				</div>
				<div class="home-topic">
					<div class="home-topic-item">
						<img :src="!topic2020On ? 'img/home_topic_01_on.png' : 'img/home_topic_01_on.png'" alt="">
						<p class="home-topic-click" @click="goTopic('2019')"></p>
					</div>
					<div class="home-topic-item">
						<img :src="topic2020On ? 'img/home_topic_02_on.png' : 'img/home_topic_02_on.png'" alt="">
						<p class="home-topic-click" @click="goTopic('2020')"></p>
					</div>
				</div>
				<button class="home-viewhb-btn" @click="goList">
					<img src="https://yunyingcdn.thecover.cn/o_1dts8mm2812aeojc1d6m157s1se54r.png" alt="">
				</button>
				<div class="home-notice" v-if="noticeList.length">
					<h5>中奖通知</h5>
					<div class="home-notice-inner">
						<ul>
							<li v-for="(noticeItem, index) in noticeList" :key="index">
								恭喜<i v-html="noticeItem.nickname"></i>获得<span v-if="noticeItem.amount">&nbsp;{{noticeItem.amount / 100}}元&nbsp;</span>现金红包
							</li>
						</ul>					
					</div>
				</div>
			</div>
			<div class="home-dynamic">
				<h4>
					<img src="../assets/img/home_dynamic_title.png" alt="">
				</h4>
				<div class="home-dynamic-inner">
					<div class="home-dynamic-main">
						<div class="home-dynamic-wrap" v-if="dynamicLoaded && dynamicList.length">
							<div class="home-dynamic-list" v-for="(listItem, listIndex) in dynamicList" :key="listIndex">
								<div class="home-dynamic-item" :class="[dynamicItem.topicId == topicData[2020].id && 'home-dynamic-item-2020']" v-for="(dynamicItem, dynamicIndex) in listItem" :key="dynamicIndex" @click="goDynamic(dynamicItem)">
									<label for=""></label>
									<div class="content">
										<div class="content-inner">
											<img class="avatar" :src="dynamicItem.avatar || 'https://yunyingcdn.thecover.cn/o_1dueg5elo1i4u1l5q1tkrs1713lb9.jpg'" alt="">
											<b v-html="dynamicItem.nick_name"></b>
											<img v-if="dynamicItem.pics || dynamicItem.video_detail" class="icon" :src="dynamicItem.video_detail ? 'https://yunyingcdn.thecover.cn/o_1dts8mm27ea219k91mdmstk1rge2v.png' : 'https://yunyingcdn.thecover.cn/o_1dts8mm271mplln71tqchagm082u.png'" alt="">
											<p v-if="dynamicItem.content" v-html="dynamicItem.content"></p>
										</div>
									</div>									
								</div>
							</div>
						</div>
						<div class="home-dynamic-notice" v-if="!dynamicLoaded">
							数据加载中，请稍后...
						</div>
					</div>
				</div>
			</div>			
        </div>  
    </div>
</template>

<script>

import CONFIG from '@/utils/config'
import COVERAPP from '@/utils/COVERAPP'
import COVER from '@/utils/COVER'

import { mapState, mapActions } from 'vuex'

export default {
    name: 'home',
    data() {
        return {
			noticeList: [],
			dynamicLines: 5,
			topic2020On: false,
			dynamicList: [],
			noticeTimeId: null,
			dynamicLoaded: false
        }
	},
	computed: {
        ...mapState(['aid', 'newsId', 'isApp', 'topicData', 'userinfo', 'maskData', 'serverTime', 'pageLoading', 'isImmerse', 'shareData', 'versionSize'])
	},
    created() {
		this.getNoticeList() 
		this.getDynamicList()	  
	},
	mounted() {
		this.checkTimeAsync().then(()=>{
			if(this.serverTime > new Date('2020/01/25 00:00:00').getTime()) {
				this.topic2020On = true
			}
			this.share()
		})
		document.body.className = 'home-body'	
		document.querySelector('.loading-wrap').style.display = 'none'	
		this.setPageLoadingAsync(false)
		setTimeout(()=> {
			COVER.track(this.aid, 'load', '首页加载')
		}, 300)	
	},
    methods: {
		...mapActions([
			'setMaskDataAsync',
			'getUserinfoAsync',
			'setPageLoadingAsync',
			'checkCanGetHb',
			'checkTimeAsync'
        ]),
		//获取通知信息
		getNoticeList() {	
			COVER.$get('/lottery/list', {
        aid: this.aid,
				rows: 100
			}).then((res) =>{
				if (res.errno === 0 && res.data && res.data.length) {
					let noticeList = res.data;
					noticeList.forEach((val, index) => {
						try {
              val.nickname = decodeURIComponent(escape(window.atob(val.nickname)))
              if(val.nickname.length > 5) {
                val.nickname = `${val.nickname.slice(0, 3)}**${val.nickname.slice(-1)}`					
              }
            }
            catch(e) {

            }
					})
					noticeList.push(noticeList[0])
					this.noticeList = JSON.parse(JSON.stringify(noticeList))
          console.log(noticeList);
					noticeList.length > 2 && this.$nextTick(() => {
						this.noticeAni()
					})
				}
			})		
		},
		// 通知轮播动画
		noticeAni() {
			let list = document.querySelector(".home-notice-inner ul");
			let itemH = document.querySelector(".home-notice-inner li").getBoundingClientRect().height;
			let itemLen = this.noticeList.length
			let index = 0;
			setInterval(()=> {
				index++
				list.className = 'ani'
				let top = index * itemH > (itemLen - 1)* itemH ? 0 : index * itemH
				let style = `-webkit-transform: translateY(${-top}px);transform: translateY(${-top}px)`
				list.setAttribute('style', style)
				setTimeout(()=> {
					if(index == itemLen - 1) {
						index = 0
						list.className = ''
						style = `-webkit-transform: translateY(0px);transform: translateY(0px)`
						list.setAttribute('style', style)
					}
				}, 300)
			}, 2000)
		},
		// 活动新年祝福动态
		getDynamicList() {
			COVER.ajax('/wap/wapTopic/topicDynamic', {
				topic_ids: [this.topicData['2019'].id, this.topicData['2020'].id],
				page_size: 200
			}).then((res)=> {
				if(res.data && res.data.data && res.data.data.dynamic && res.data.data.dynamic.length) {
					let list = res.data.data.dynamic
					this.dynamicLoaded = true
					this.splitDynamicList(list)
				} else {
					this.dynamicLoaded = true
				}
			}).catch((err) =>{
				this.dynamicLoaded = true
			})
		},
		// 拆分动态数据
		splitDynamicList(list) {
			let newList = [];
			let oldList = list;
			let len = list.length;
			for (let j = 0; j < this.dynamicLines; j++) {
				newList[j] = []
				for (let i = 0; i < len; i++) {
					if (i % this.dynamicLines == j) {
						let content = list[i].content.length > 20 ? list[i].content.slice(0, 20) + '...' : list[i].content
						content = content.replace(/<(?:.|\s)*?>/g, '').replace(/[\n\r]/g, " ").replace(/↵/g, " ");
                    	list[i].content = COVER.renderReplyContent(content);
						newList[j].push(list[i])
					}
				}
			}
			this.dynamicList = JSON.parse(JSON.stringify(newList));
			this.$nextTick(() =>{
				this.setListStyle()
			})
		},
		// 弹幕动画
		setListStyle() {
			let listDom = document.querySelectorAll('.home-dynamic-list')
			let listLen = listDom.length
			let wrapW = document.querySelector('.home-dynamic-wrap').getBoundingClientRect().width
			for(let i = 0; i < this.dynamicLines; i++) {
				let item = listDom[i].querySelectorAll('.home-dynamic-item')
				let itemLen = item.length
				let listW = 0
				for(let itemI = 0; itemI < itemLen; itemI++) {					
					listW += item[itemI].getBoundingClientRect().width + Math.ceil(parseFloat(window.getComputedStyle(item[itemI],null).marginRight))
				}
				listW += wrapW
				let style =`width: ${listW}px;-webkit-animation: dynamicMove ${6*itemLen}s linear infinite;-animation: dynamicMove ${6*itemLen}s linear infinite`
				listDom[i].setAttribute('style', style)
			}
		},
		checkGo(link, loginFlag) {
			let _this = this
			if(!this.isApp) {
				COVER.$getScript(CONFIG.DOWNLOAD_ADDRESS).then(()=> {
					COVER.downloadApp(this.aid, 14, this.newsId)
				})
				return false;
			}
			if(!this.userinfo.user_id && loginFlag) {
				this.setMaskDataAsync({
					type: 4,
					text: '亲，请登录app参与活动可获得红包哦！',
					btns: [
						{
							className: 'close-btn',
							text: '取消'
						},
						{
							className: 'login-btn',
							text: '确定',
							// link: link,
							// fn() {
							// 	_this.setMaskDataAsync(null)
							// 	COVERAPP.Method.OpenLogin({
							// 		callback (ret) {
							// 			let userinfo = typeof ret == "string".toLowerCase() ? JSON.parse(ret) : ret;
							// 			if (!COVER.isEmpty(userinfo.user_id)) {
							// 				_this.getUserinfoAsync()
							// 				setTimeout(() => {
							// 					_this.$router.push(link)	
							// 				}, 500)																														
							// 			}
							// 		}
							// 	})
							// }
						}
					]
				})
				return false
			}
			return true
		},
		goTopic(id) {
      const _this = this;
			let link = `/game?type=${ id == '2019' ? 0 : 1 }`
			if(this.checkGo(link, true)) {
				COVERAPP.Method.goVideoCapture({
          topicId: this.topicData[id].id,
          topicName: this.topicData[id].title,
          callback(ret) {
            try {
              let data = JSON.parse(ret);
              if(data.status == 1){
                _this.checkCanGetHb(1).then(()=> {
                  _this.$router.push(link)
                })
              }
            }
            catch(e) {

            }
          }
        })
			}
		},
    goList() {
			COVER.track(this.aid, 'click', '查看我的红包')
			let link = `/list`
			if(this.checkGo(link, true)) {
				this.$router.push(link);
			}
		},
		goRule() {
			COVER.track(this.aid, 'click', '查看规则')
			this.$router.push(`/rule`);
		},
		goDynamic(data) {
			let year = data.topicId == this.topicData[2020].id ? '2020' : '2019'
			COVER.track(this.aid, 'click', `查看${year}话题动态`)
			let link = `/dynamic?year=${year}&id=${data.dynamic_id}`
			if(this.checkGo(link, false)) {
				this.$router.push(link)
			}			
		},
		share() {
			let _this = this
			let ShareData = JSON.parse(JSON.stringify(this.shareData))
			ShareData.callback = function(ret) {
				if(!_this.isApp) {
					COVER.track(_this.aid, 'share', '分享'); 
					return
				}
				var data = typeof ret == "string".toLowerCase() ? JSON.parse(ret) : ret; 
				var origin = data.origin || '';
				if(origin != 'None' && !COVER.isEmpty(origin)){
					COVER.track(_this.aid, 'share', '分享链接到'+origin);  
				} else {
					COVER.track(_this.aid, 'share', '分享'); 
				}
				if((data.status == 'success' || data.status == '1') && _this.userinfo.user_id){
					_this.checkCanGetHb(2).then(()=> {
						COVER.track(_this.aid, 'load', '红包雨页面加载')	
						_this.$router.push('/game?type=2')
					})
				}           
			}
      COVER.share(ShareData)
			/* if (!this.isImmerse) {
				COVER.share(ShareData)
			}		 */
		}
    }
}
</script>

<style lang="less">
    .home-wrapper {
		background: #d6291b url(https://yunyingcdn.thecover.cn/o_1du49abgvc2a12ms19al3b91e3o9.jpg) repeat-y center top;
		background-size: 100% auto;
		position: relative;
		&.maskshow .home-inner{
			-webkit-transform: scale(1.05);
			transform: scale(1.05);
			filter: blur(8px);
		}
	}
	
	.home-inner {
		position: relative;
		z-index: 1;
		background: url('https://yunyingcdn.thecover.cn/o_1hbdet0j83lkje71rhg1ggcaage.jpg') no-repeat;
		background-position: center 7.648953rem;
		background-size: 100% auto;
	}
	.banner {
		height: 8.05153rem;
		position: relative;
		margin-bottom: 1rem;
		.time {
			font-family: "fzcysc_GBK";
			font-size: .337118rem;
			color: #f8d196;
			position: absolute;
			width: 100%;
			text-align: center;
			line-height: 1.3;
			bottom: .281804rem;
			letter-spacing: .024155rem;
		}
	}
	.home-main {
		background: url(https://yunyingcdn.thecover.cn/o_1dts8mm261cci1di412no1ngth7b2n.jpg) no-repeat center bottom;
		background-size: 100% auto;
		overflow: hidden;
	}
	.home-rule {
		color: #f8d196;
		padding-left: 1.207729rem;
		.home-rule-content {
			font-size: .304428rem;
			line-height: 1.5;
			overflow: hidden;
      padding-right: 1.207729rem;
      box-sizing: border-box;
			p{
				letter-spacing: .048309rem;
			}
		}
	}
	.rule-title {
		width: 3.784219rem;
		margin: 0 auto .241546rem;
		padding-right: 1.207729rem;
	}
	.rule-link {
		cursor: pointer;
		text-align: center;
		display: inline-block;
		font-size: 0;
		vertical-align: top;
		position: relative;
		z-index: 2;
		.rule-link-inner {
			display: inline-block;
			border-bottom: .032206rem solid #f8d196;
		}
		img {
			width: .241546rem;
			vertical-align: top;
			margin-top: 0.05rem;			
		}
		span {
			font-size: .260548rem;
			color: #f8d196;
			display: inline-block;
			vertical-align: top;
			font-weight: bold;
			line-height: 1.3;
			padding-left: .064412rem;
		}
	}
	.home-topic {
		letter-spacing: -4px;
		text-align: center;
		padding: .402576rem 0 .708535rem;
	}
	.home-topic-item {
		width: 4.235105rem;
		display: inline-block;
		margin: 0 .257649rem;
		height: 3.31723rem;
		position: relative;
		cursor: pointer;
		img {
			position: absolute;
			width: 5.41868rem;
			left: -0.515298rem;	
			top: -.676329rem;
		}
		&::after {
			content: '';
			width: .386473rem;
			height: .515298rem;
			background: url(https://yunyingcdn.thecover.cn/o_1dtuv9bg8ikl1bjr1tjq1pgo1tlfc.png) no-repeat center top;
			background-size: 100% 100%;
			position: absolute;
			right: .628019rem;
			bottom: .923349rem;
      animation: topicScale 1s 0s ease infinite;
		}
		&:last-child{
			&::after {
				right: .587762rem;
			}
			img {
				left: -0.676329rem;
			}						
		}
		p {
			position: absolute;
			width: 100%;
			height: 100%;
			left: 0;
			top: 0;
			z-index: 2;
			cursor: pointer;
		}
	}
	.home-viewhb-btn {
		width: 6.884058rem;
		margin: 0 auto;
		padding-left: .048309rem;
		margin-bottom: .177134rem;
		display: block;
	}
	.home-notice {
		width: 7.342995rem;
		height: .57971rem;
		line-height: .57971rem;
		border-radius: .57971rem;
		background-color: #b91002;
		margin: 0 auto;
		overflow: hidden;
		position: relative;
		z-index: 2;
		h5 {
			height: 100%;
			width: 2.359098rem;
			font-size: .302335rem;
			color: #f8d196;
			background-color: rgba(162, 13, 1, 0.8);
			border-radius: .57971rem;
			padding-left: .740741rem;
			position: absolute;
			left: 0;
			top: 0;
			letter-spacing: .032206rem;
			box-sizing: border-box;
			&::before {
				content: '';
				height: 100%;
				width: .297907rem;
				position: absolute;
				top: 0;
				left: .273752rem;
				background: url(https://yunyingcdn.thecover.cn/o_1dts8mm274ms16iq1tq5h3c3sn3p.png) no-repeat;
				background-position: left center;
				background-size: 100% auto;
			}
		}
	}
	.home-notice-inner {
		margin-left: 2.359098rem;
		overflow: hidden;
		ul {
			padding: 0 .354267rem 0 .225443rem;
			&.ani {
				transition: all 0.3s linear;
			}
		}
		li {
			color: #f8d196;
			font-size: .253382rem;
			i {
				font-style: normal;
			}
		}
	}
	.home-dynamic {
		background: url(https://yunyingcdn.thecover.cn/o_1dts8mm26g2hm8nc421im0190s2o.jpg) no-repeat center top;
		background-size: 100% auto;
		padding-top: 3.164251rem;
		position: relative;
		margin-top: -0.426731rem;
		padding-bottom: .982287rem;
	}
	.home-dynamic-inner {
		height: 6.602254rem;
		background-color: #f8d196;
		margin: -0.322061rem .386473rem 0;
		border-radius: .241546rem;
		padding: .152979rem;
		box-shadow: 0 .161031rem .152979rem rgba(0,0,0,0.2);
		box-sizing: border-box;
		position: relative;
	}
	.home-dynamic-main {
		background-color: #d6291b;
		box-shadow: 0 .032206rem .056361rem rgba(0,0,0,0.2);
		height: 100%;
		border-radius: .161031rem;
	}
	.home-dynamic-wrap {
		overflow: hidden;
		width: 100%;
		height: 100%;
		box-sizing: border-box;
		padding: .161031rem 0;
	}
	.home-dynamic-list {
		height: 1.006441rem;
		white-space: nowrap;
		position: relative;
		left: 100%;
		letter-spacing: -4px;
		margin-bottom: .161031rem;
		backface-visibility:hidden;
	}
	.home-dynamic-item {
		display: inline-block;
		margin-right: .257649rem;
		height: 100%;
		cursor: pointer;
		label {
			height: 100%;
			display: inline-block;
			width: 1.553945rem;
			background: url('../assets/img/2019_icon.png') no-repeat left bottom;
			background-size: 100% auto;			
		}
		&.home-dynamic-item-2020 label{
			background-image: url('../assets/img/2020_icon.png');
		}
		.content {
			display: inline-block;
			padding-left: .161031rem;
			vertical-align: bottom;
			position: relative;
			height: .57971rem;
			overflow: hidden;
			&::before {
				content: '';
				position: absolute;
				left: -0.6rem;
				top: -0.3rem;
				width: 0;
				height: 0;
				border: 0.6rem solid;
				border-right: 0.3rem solid;
				border-color: transparent #f8d196 transparent transparent;
			}
		}
		.content-inner {
			padding: 0 .241546rem 0 .112721rem;
			background-color: #f8d196;
			height: 100%;	
			line-height: .57971rem;	
			position: relative;
			z-index: 1;	
			display: inline-flex;
			align-items: center;
			letter-spacing: 0;
			.avatar {
				width: .466989rem;
				height: .466989rem;
				border-radius: 50%;
			}
			b {
				color: #d6291b;
				font-size: .302335rem;
				font-weight: bold;
				padding-left: .096618rem;
			}
			p {
				color: #d6291b;
				font-size: .253382rem;
				padding-left: .225443rem;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
				img {
					width: 0.35rem;
					vertical-align: middle;
					height: auto;
				}
			}
			.icon {
				width: .41868rem;
				margin-left: .241546rem;
			}
		}
	}
	.home-dynamic-notice {
		font-size: 0.4rem;
		color: #f8d196;
		text-align: center;
		position: relative;
		top: 50%;
		transform: translateY(-50%);
	}

	@keyframes noticeMove {
		from {
			transform: translateY(0)
		}
		to {
			transform: translateY(-100%)
		}
	}

	@keyframes dynamicMove {
		from {
			transform: translate3d(0, 0, 0)
		}
		to {
			transform: translate3d(-100%, 0, 0)
		}
	}
  @keyframes topicScale {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.2);
    }
    100% {
      transform: scale(1);
    }
  }
</style>